import React, { useEffect, useRef, useState } from 'react';
import './ProjectsCard.css';
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

const useIntersectionObserver = (setIsVisible) => {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.unobserve(node);
        }
      },
      { root: null, rootMargin: '0px 0px -100px 0px', threshold: 0.1 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [setIsVisible]);

  return ref;
};

function ProjectsCard({ data, lite = false }) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useIntersectionObserver(setIsVisible);
  const text = 'Featured - Featured - ';

  const renderRotatedText = () => {
    const characters = text.split('');

    return characters.map((char, index) => (
      <span className="rotateLetter" key={index} style={{ transform: `rotate(${index * (360 / characters.length)}deg)` }}>
        {char}
      </span>
    ));
  };

  const className = `${data.double ? data.featured ? 'projectCard featured double' : 'projectCard double' : "projectCard"} ${isVisible ? 'visible' : ''}`;

  const body = (
    <>
      {data.featured ? (
        <div className="featuredCircle" aria-hidden="true">
          <p className="featured-circle-text">{renderRotatedText()}</p>
          <span className="starCircle">&#x2605;</span>
        </div>
      ) : null}
      <Link to={data.link}>
        <div className="projectCardText">
          <h3>{data.title}</h3>
          <p>{data.desc}</p>
        </div>
        <img src={data.img} alt={`${data.title} icon`} loading="lazy" decoding="async" />
      </Link>
    </>
  );

  if (lite) {
    return (
      <div
        ref={ref}
        className={className}
        style={{ opacity: isVisible ? 1 : 0, transition: 'opacity 0.35s ease' }}
      >
        {body}
      </div>
    );
  }

  return (
    <motion.div
      ref={ref}
      layout
      animate={{ opacity: isVisible ? 1 : 0 }}
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      className={className}
    >
      {body}
    </motion.div>
  );
}

export default ProjectsCard;
